import styled from 'styled-components';
import {colorPalette, defaultSize, viewSize} from '../../config';
import {
	mainDesktopImg,
	secondSectionImg,
	mainMobileImg,
} from '../../config/images';

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const FirstSection = styled.div`
	display: flex;
	flex-direction: column;
	background-image: url(${(props) =>
		props.bgImg ? props.bgImg.desktop : mainDesktopImg});
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	height: ${(props) => (props.height ? props.height.desktop : '100vh')};

	@media screen and (max-width: ${viewSize.tablet}) {
		background-image: url(${(props) =>
			props.bgImg ? props.bgImg.desktop : mainMobileImg});
		background-size: cover;
		background-position: none;
	}
`;

export const FirstTextWrapper = styled.div`
	width: 98%;
	max-width: ${defaultSize.desktopContainer};
	margin: 9rem auto auto;
	box-sizing: border-box;
	> button {
		width: 152px;
		height: 54px;
		margin-top: 57px;
	}

	> h2 {
	}

	> p {
	}
	@media screen and (max-width: ${viewSize.tablet}) {
		> button {
			width: 152px;
		}
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		margin: 4rem 1.5rem;
		width: auto;
		> button {
			width: 104px;
			height: 36px;
			margin-top: 33px;
		}
	}
`;

export const DateWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 98%;
	max-width: ${defaultSize.desktopContainer};
	margin: auto auto 10rem auto;

	@media screen and (max-width: ${viewSize.mobile}) {
		margin: 4rem 1.5rem;
		width: auto;
	}
`;

export const DateTextWrapper = styled.div`
	margin-bottom: 2rem;
`;

export const DateItemWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
`;

export const DateItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	height: 6rem;

	@media screen and (max-width: ${viewSize.mobile}) {
		width: 50%;
		margin: 2rem 0;
	}
`;

export const SecondSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 5.5rem auto 7rem auto;

	width: 98%;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
`;

export const InfoWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: ${defaultSize.desktopContainer};
	margin-bottom: 4rem;

	@media screen and (max-width: ${viewSize.mobile}) {
		flex-direction: column;
	}
`;

export const InfoTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 20%;

	> span {
		margin-bottom: 1rem;
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
	}
`;

export const ImgTextWrapper = styled.div`
	display: flex;
	width: 80%;
	flex-wrap: wrap;
	justify-content: space-around;

	> div > div {
		margin-top: 1rem;
	}

	> div {
		margin: 1rem;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;

		> div {
			margin: 2rem;
		}
	}
`;

export const SupportWrapper = styled.div`
	display: flex;
	//flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	width: 100%;
	align-items: center;
	max-width: ${defaultSize.desktopContainer};
	background-color: ${colorPalette.card};
	border-radius: 1rem;
	padding: 1rem 0;
	min-height: 7rem;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		flex-direction: column;
	}
`;

export const Support = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	// justify-content: space-evenly;
	justify-content: center;
	width: auto;
	min-width: 300px;
	margin: auto;
	margin: 10px 10px 10px 0;
	> img {
		height: 37px;
		margin: auto 0.3rem;
	}
	@media screen and (max-width: ${viewSize.tablet}) {
		margin: auto 1rem;
		> img {
			width: 100%;
			height: auto;
		}
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		> img {
		}
	}
`;

export const SupportText = styled.div`
	// width: '55px',
	// height: '30px',
	background-color: #10193a;
	color: white;
	padding: 3px 10px;
	margin-right: 10px;
	font-weight: 700;
	border-radius: 10px;
`;

export const SupportImg = styled.img`
	${(props) => (props.desktop ? `display : inline;` : `display : none;`)}
	@media screen and (max-width: ${viewSize.tablet}) {
		${(props) => (props.tablet ? `display : inline;` : `display : none;`)}
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		${(props) => (props.mobile ? `display : inline;` : `display : none;`)}
	}
`;

export const ThirdSection = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	background-image: url(${(props) =>
		props.bgImg ? props.bgImg.desktop : secondSectionImg});
	background-repeat: no-repeat;
	background-size: cover;
	padding: 7rem 0px;
	margin-bottom: 1rem;
	@media screen and (max-width: ${viewSize.tablet}) {
		padding: 5rem 0px;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		padding: 5rem 0px;
	}
`;
export const ThirdTextWrapper = styled.div`
	max-width: ${defaultSize.desktopContainer};

	width: 98%;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}

	@media screen and (max-width: 1100px) {
		margin: 1rem;
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
`;

export const ThirdCardWrapper = styled.div`
	max-width: ${defaultSize.desktopContainer};
	display: flex;
	justify-content: space-between;
	margin : auto;
	width: 98%;
	margin-top:30px;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
	@media screen and ( max-width : 1100px) {
		flex-direction: column;
		align-items: center;
		
		> div {
			margin : 1rem 0;
		}
	}
	
	
}
`;

export const FourthSection = styled.div`
	padding: 80px 0 133px 0;
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	width: 98%;
	margin: auto;

	@media screen and (max-width: ${viewSize.tablet}) {
		width: 100%;
	}

	@media screen and (max-width: ${viewSize.mobile}) {
	}
`;
